import styled from 'styled-components';
import { toRem, theme } from '@marriott/mi-ui-library-shop';
import { StyledPopupProps } from './popup.types';
import { StyledPopupHeaderDiv } from '../popupHeader/popupHeader.styles';
import { StyledPopupMain } from '../popupMain/popupMain.styles';

export const StyledPopupDiv = styled.div<StyledPopupProps>(({ show, width }) =>
  show
    ? `
    overflow: visible;
    width: 100%;
    position: relative;
    @media ${theme.mediaQuery.tablet} {
        position: absolute;
        top: 0;
        inset-inline-start: ${toRem(-8)};
        width: auto;
        width: ${toRem(352)};
        height: auto;
        max-height: ${toRem(590)};
        border-radius: ${toRem(14)};
        z-index: 3;
        padding: ${toRem(20)} ${toRem(24)};
        &:not(.dest-popup) {
            overflow: hidden;
            overflow-y: auto;
            background: ${theme.color.white};
            box-shadow: ${theme.color['cta-banner-shadow']};
        }
        &.dest-popup {
            ${StyledPopupHeaderDiv},
            ${StyledPopupMain} {
                background: ${theme.color.white};
                box-shadow: ${theme.color['cta-banner-shadow']};
            }
            ${StyledPopupHeaderDiv} {
                border-radius: ${toRem(14)} ${toRem(14)} 0 0;
                &:after {
                    content: '';
                    position: absolute;
                    bottom: -${toRem(10)};
                    inset-inline-start: 0;
                    width: 100%;
                    height: ${toRem(10)};
                    background: ${theme.color.white};
                }
                .dashed-border:after {
                    display: none;
                }
            }
            ${StyledPopupMain} {
                border-radius: 0 0 ${toRem(14)} ${toRem(14)};
                width: ${width};
            }
        }
    }

    @media ${theme.mediaQuery.desktop} {
        padding: ${toRem(23)} ${toRem(32)};
        width: ${toRem(386)};
    }
    @media ${theme.mediaQuery.largeDesktop} {
        padding: ${toRem(23)} ${toRem(40)};
        width: ${toRem(402)};
    }

`
    : ''
);
